import { render, staticRenderFns } from "./withdrawals-dashboard.vue?vue&type=template&id=4d8fdb72&scoped=true"
import script from "./withdrawals-dashboard.component.js?vue&type=script&lang=js&external"
export * from "./withdrawals-dashboard.component.js?vue&type=script&lang=js&external"
import style0 from "./withdrawals-dashboard.vue?vue&type=style&index=0&id=4d8fdb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8fdb72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VIcon,VMenu,VProgressCircular,VTextField})
